import { useQuery } from '@tanstack/react-query';
import { useUserIdentityState } from '@provider/user-identity';
import { DAYS_TO_MS, SECONDS_TO_MS } from '@utils/constants';
import { fetchDialoguesRequest } from './api.get-dialogues.request.js';

const getDialoguesKey = (user, dialogueId) => ["user-area/dialogues/get", user?.id, dialogueId];
const getDialoguesQuery = (user, dialogueId) => {
  return {
    queryKey: getDialoguesKey(user, dialogueId),
    queryFn: () => fetchDialoguesRequest(dialogueId),
    staleTime: 15 * SECONDS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  };
};
const useDialoguesQuery = (dialogueId, extraConfig) => {
  const user = useUserIdentityState(state => state.user);
  return useQuery({
    ...getDialoguesQuery(user, dialogueId),
    ...extraConfig
  });
};

export { getDialoguesKey, getDialoguesQuery, useDialoguesQuery };
//# sourceMappingURL=api.get-dialogues.query.js.map
